import { Component, inject, Input, OnInit } from '@angular/core';
import { HeaderConfigurationComponent } from '../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import { InformationTitleComponent } from '../../../../../../../components/ecosystems/information-title/information-title.component';
import {
  IonButton,
  IonContent,
  ModalController,
} from '@ionic/angular/standalone';
import { LabelDescriptionComponent } from '../../../../../../../components/ecosystems/label-description/label-description.component';
import { LargedLinkComponent } from '../../../../../../../components/ecosystems/larged-link/larged-link.component';
import { TranslatePipe } from '@ngx-translate/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../manager/edro-network-manager';
import { Pool, PoolAdditionalData } from '../../../../../../../apis/pool.api';
import { IProduct } from '../../../../IProduct';
import { TwoChoicesModalComponent } from '../../../../../../../components/ecosystems/two-choices-modal/two-choices-modal.component';
import { P00062PositionType } from '../../Enum/P00062PositionType';

@Component({
  selector: 'app-p00062-installation-position-pac-poly',
  templateUrl: './p00062-installation-position-pac-poly.component.html',
  styleUrls: ['./p00062-installation-position-pac-poly.component.scss'],
  imports: [
    HeaderConfigurationComponent,
    InformationTitleComponent,
    IonButton,
    IonContent,
    LabelDescriptionComponent,
    LargedLinkComponent,
    TranslatePipe,
  ],
})
export class P00062InstallationPositionPacPolyComponent implements OnInit {
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  private modalController: ModalController = inject(ModalController);
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() pool: Pool | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  ppPositionRaccordementPACPoly: number = 0;

  constructor() {}

  async openPositionModal() {
    const modal = await this.modalController.create({
      component: TwoChoicesModalComponent,
      componentProps: {
        title: 'P00062.modal.positionraccordement.title',
        value: this.ppPositionRaccordementPACPoly,
        firstChoice: {
          title: 'P00062.modal.positionraccordement.option0',
          image:
            '/assets/ecosystem/images/products/P00062/P00061-position-0.png',
          value: 0,
        },
        secondChoice: {
          title: 'P00062.modal.positionraccordement.option1',
          image:
            '/assets/ecosystem/images/products/P00062/P00061-position-1.png',
          value: 1,
        },
      },
      cssClass: 'dynamic-height',
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      this.ppPositionRaccordementPACPoly = data.value;
    }
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );

    this.ppPositionRaccordementPACPoly =
      this.poolAdditionalData?.ppPositionRaccordementPACPoly ?? 0;
  }

  onSubmit() {
    this.poolAdditionalData!.ppPositionRaccordementPACPoly =
      this.ppPositionRaccordementPACPoly!;
    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  protected readonly P00062PositionType = P00062PositionType;
}
